<script>
    import {_} from 'svelte-i18n';
    import PackListing from '../PackListing.svelte';
    import {onMount} from 'svelte';
    import {goTo} from "../../utils.js";
    import {storePacks} from "../../stores.js";

    onMount(() => {
        window.scrollTo(0, 0);
        goTo('/supplies/specialEvents?tab=specialEvents', true);
    });

    let hasImagePacks = $derived(
        ($storePacks || []).some(pack =>
            pack.storeSection === 'specialEvents' &&
            (pack.bundleName?.startsWith('fortunepack') || pack.bundleName?.startsWith('wheeloffortune')) &&
            (!pack.endAt || new Date(pack.endAt).getTime() > Date.now())
        )
    );

    let hasOtherPacks = $derived(
        ($storePacks || []).some(pack =>
            pack.storeSection === 'specialEvents' &&
            !pack.perks?.some(p => p.startsWith('battlePass')) &&
            !pack.bundleName?.startsWith('fortunepack') &&
            !pack.bundleName?.startsWith('wheeloffortune') &&
            (!pack.endAt || new Date(pack.endAt).getTime() > Date.now())
        )
    );
</script>

{#if hasImagePacks}
    <PackListing storeSection="eventImagePacks" title={$_('EventsWindowTitle')}/>
{/if}
{#if hasOtherPacks}
    <PackListing storeSection="specialEvents" title={hasImagePacks ? '' : $_('EventsWindowTitle')}/>
{/if}
